import React from "react";
import {ActionButton} from "../../designSystem/components/ActionButton";

interface NextStepButtonProps {
  onClick: () => void;
}

export const NextStepButton = ({ onClick }: NextStepButtonProps) => (
  <ActionButton
    fullWidth
    label="下一步"
    iconName="fa-circle-arrow-right"
    onClick={onClick}
  />
)